export default __webpack_public_path__ + "static/media/interests.311391e8.svg";